@if (upsellProducts?.length !== 0 ) {
  <h3 class="upsell-header my-header" >
    <mibp-resource-string key="Upsell_UpgradeSaveMoney"></mibp-resource-string>
  </h3>
}

@if (isLoading) {
  <mibp-loader></mibp-loader>
}

@if (upsellProducts?.length !== 0 ) {
  <div  class="columns" [ngClass]="{'hidden': this.isLoading}">
    @for (upsellProduct of upsellProducts; track upsellProduct) {
      <div class="column">
        <section class="upsell-card">
          <div class="image-container">
            <a   (click)="onClickProductImage(upsellProduct.code)">
              @if (upsellProduct.partsPictureImageUrl) {
                <mibp-image [urlOfImage]="upsellProduct.partsPictureImageUrl"> </mibp-image>
              }
              @if (!upsellProduct.partsPictureImageUrl) {
                <img  src="assets/images/NewDefaultImage.png" alt="image missing">
              }</a>
            </div>
            
              <h4 class="item-title" >
                <a  (click)="onClickProductImage(upsellProduct.code)">{{upsellProduct.name}}</a>
                <mibp-support-team-product-state-menu [quantity]="upsellProduct.quantity" [productCode]="upsellProduct.code"></mibp-support-team-product-state-menu>
              </h4>
            
              <div class="upsell-card-info">
                <ul class="item-list">
                  <li class="item-name"> <span class="item-label"><mibp-resource-string key="Global_ProductNumber"></mibp-resource-string>: </span> {{upsellProduct.code}}</li>
                  @if (canSeeAvailability) {
                    <li class="item-availability">
                      <span class="item-label"><mibp-resource-string key="Global_ProductAvailability"></mibp-resource-string>@if (availabilityStateCmp.isLoaded() && availabilityStateCmp.totalAvailability() > 0) {
                    <span  translate="no" class="material-icon material-icon--fill availability-help-icon" (click)="availabilityStateCmp.openPopover($event.target)">help</span>
                  }:</span>
                    <div class="item-availability__wrapper">
                      <!-- TODO: We do not check if this is a rock tool item here-->
                      <mibp-availability-state
                        #availabilityStateCmp
                        [productCode]="upsellProduct.code"
                        [quantity]="upsellProduct.quantity"
                        [isRestrictedByAvailability]="upsellProduct.isRestrictedByAvailability"
                      ></mibp-availability-state>
                    </div>
                  </li>
                }
                @if (canSeeExpectedDeliveryDate) {
                  <li  class="item-availability">
                    <span class="item-label"><mibp-resource-string key="Global_ExpectedDeliveryDate"></mibp-resource-string>: </span>
                    <div class="item-availability__wrapper">

                      <mibp-expected-delivery-date-state
                        [quantity]="upsellProduct.quantity"
                        [productCode]="upsellProduct.code"
                        [isRestrictedByExpectedDeliveryDate]="upsellProduct.isRestrictedByExpectedDeliveryDate"
                    ></mibp-expected-delivery-date-state>
                    </div>
                  </li>
                }
                <li><span class="item-label"><mibp-resource-string key="Upsell_UpgradeText"></mibp-resource-string>: </span>{{upsellProduct.upsellUpgradesProductCode}}</li>
                
                <ng-template 
                  #priceStateContext="priceStateContext"
                  [priceStateContextSource]="priceAndAvailabilitySource"
                  [priceStateContext]="upsellProduct.code" 
                  let-showPrice="showPrice">
                  @if (showPrice) {
                    <li class="item-price">
                      <mibp-price-state
                        [productCode]="upsellProduct.code"
                        [source]="priceAndAvailabilitySource"
                        [isRestrictedByPrice]="upsellProduct.isRestrictedByPrice">
                      </mibp-price-state>
                    </li>
                  }
                </ng-template>
              </ul>
              <div class="upgrade-btn">
                <button type="button" data-gtm="upgrade-product-btn" class="my-button upsell-btn" (click)="onUpgradeProduct(upsellProduct)"><mibp-resource-string key="Upsell_UpgradeProductBtn"></mibp-resource-string></button>
              </div>
            </div>
          </section>
        </div>
      }
    </div>
  }
